<script>
    export default {
        props: ["icon", "title", "descr"]
    };
</script>


<template>
    <div class='fluid__btnsection'>
        <div class='fluid__btnsection__icon'>
            <i class='material-icons'>{{ icon }}</i>
        </div>

        <div class='fluid__btnsection__info'>
            <span>{{ title }}</span>
            <span>{{ descr }}</span>
            <i class='material-icons back-efect'>{{ icon }}</i>
        </div>
    </div>
</template>

<style>
    .fluid__btnsection {
        position: relative;
        display: flex;
        align-items: center;
        height: 75px;
        max-width: 100%;

        margin: 8px;
        margin-bottom: 0;
        overflow: hidden;
        text-decoration: none;
        border-right: 3px solid #063e5f;
        transition: all 0.3s ease;
        background-color: #fff;
        border: 1px solid #ccc;
        border-radius: 5px 5px 5px 5px;
    }
    .theme--dark.application .fluid__btnsection {
        background-color: #212121;
        border: 1px solid #000;
    }

    .fluid__btnsection__icon {
        display: flex;
        justify-content: center;
        align-items: center;
        min-width: 50px;
        height: 50px;
        width: 50px;
        border-radius: 50%;
        margin-left: 10px;
        background-color: #064970;
    }
    .theme--dark.application .fluid__btnsection__icon {
        background-color: #fff;
    }

    .fluid__btnsection__icon i {
        color: #fff;
        font-size: 30px;
    }

    .theme--dark.application .fluid__btnsection__icon i {
        color: #000;
    }

    .fluid__btnsection__info {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-left: 10px;
    }

    .fluid__btnsection__info span {
        font-size: 1.25rem;
        font-weight: 600;
        z-index: 2;
    }
    .fluid__btnsection__info span:nth-child(2) {
        font-size: 1rem;
        font-weight: 400;
    }
    .theme--light.application .btn-section__info span {
        color: #000;
    }

    .theme--light.application .btn-section__info span:nth-child(2) {
        color: rgba(0, 0, 0, 0.6);
    }

    .back-efect {
        position: absolute;
        top: -5px;
        right: 0;
        color: rgba(0, 0, 0, 0.07);
        font-size: 100px;
    }

    .theme--dark.application .back-efect {
        color: #303030;
    }
</style>
